module.exports = __webpack_public_path__ + "img/Ashley.5fd708fe.jpeg";